import { hasClerkUser } from '@/biz/tool';
import { useLoginStore } from '@/hooks/useLoginStore';
import { Tooltip } from 'aha-components';
import AccountMenuIcon from './AccountMenuIcon';

export default function Avatar({
  compact,
  menuHeader
}: {
  compact?: boolean;
  menuHeader?: boolean;
}) {
  const { channelAvatar, channelName, userEmail } = useLoginStore();
  const avatarImg = (
    <span className="creator-avatar-frame shrink-0 cursor-pointer">
      <span className="creator-avatar-frame__inner">
        <img
          alt="avatar"
          src={
            hasClerkUser()
              ? channelAvatar || '/c-avatar-empty.svg'
              : '/c-avatar-empty.svg'
          }
          className="h-full w-full rounded-full object-cover"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = '/c-avatar-empty.svg';
            console.error('youtube avatar failed!!! ' + channelAvatar);
          }}
        />
      </span>
    </span>
  );

  if (compact) {
    return avatarImg;
  }

  if (menuHeader) {
    return (
      <div className="flex items-center gap-2 px-3 py-3">
        {avatarImg}
        <div className="min-w-0 flex-1 font-['Inter'] text-sm leading-5">
          <div className="truncate font-semibold text-[var(--creator-sidebar-account-title)]">
            {channelName || '-'}
          </div>
          <div className="truncate font-normal text-[var(--creator-sidebar-account-secondary)]">
            {userEmail}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-16 cursor-pointer justify-between gap-2 rounded-xl border border-[#D4D4D4] p-[11px]">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {avatarImg}
        <div className="flex min-w-0 flex-1 flex-col items-start justify-start">
          <Tooltip content={channelName} className="w-full">
            <div className="w-full overflow-hidden text-ellipsis whitespace-nowrap font-['Inter'] text-sm font-semibold leading-5 text-[var(--creator-sidebar-account-title)]">
              {channelName || '-'}
            </div>
          </Tooltip>
          <Tooltip content={userEmail} className="w-full">
            <div className="w-full overflow-hidden text-ellipsis whitespace-nowrap font-['Inter'] text-sm font-normal leading-5 text-[var(--creator-sidebar-account-secondary)]">
              {userEmail}
            </div>
          </Tooltip>
        </div>
      </div>
      <div className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-md bg-[var(--creator-sidebar-surface)]">
        <AccountMenuIcon
          name="selector-vertical"
          className="h-5 w-5 text-[var(--creator-sidebar-icon)]"
        />
      </div>
    </div>
  );
}
